module.exports = __webpack_public_path__ + "static/media/dataaeps.96fea5d5.png";